import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { withRouter } from 'react-router-dom';
import StructureContainers from '@Services/StructureContainers';
import handlers from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptionsDialogHandlers';
import {
  initialOptions as initialOptionsSelector,
  isSimilarOptionChecked as isSimilarOptionCheckedSelector,
  ownCurrentOptions as ownCurrentOptionsSelector,
  currentOptionsNameValueObjectsArray as currentOptionsNameValueObjectsArraySelector,
} from '@Containers/StructureOptions/StructureOptionsSelecors';
import {
  fetchAndCreateInitialOptionsCopy as fetchAndCreateInitialOptionsCopyAction,
  setCurrentOptionsSameAsSaved as setCurrentOptionsSameAsSavedAction,
  toggleCheckboxOption as toggleCheckboxOptionAction,
  toggleRadioOption as toggleRadioOptionAction,
  toggleSubRadioOption as toggleSubRadioOptionAction,
  updateInputValue as updateInputValueAction,
  updateSavedInfoWithCurrent as updateSavedInfoWithCurrentAction,
} from '@Containers/StructureOptions/StructureOptionsActions';
import StructureOptions from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptions';

import './StructureOptionsContainer.scss';

const StructureOptionsWithHandlers = handlers(StructureOptions);

export function StructureOptionsContainer(props) {
  const { id, onCurrentOptionsChange, fetchAndCreateInitialOptionsCopy, isVerticalLayout, currentOptionsList, ownCurrentOptions } = props;
  const [showMore, setShowMore] = useState(true);
  // To make it work with StructureOptionsDialogHandlers
  const updateStructureOptionsDialog = ({ showMore: _showMore }) => {
    setShowMore(_showMore);
  };

  function updateStructureOptions(optionsList) {
    if (typeof onCurrentOptionsChange === 'function') {
      onCurrentOptionsChange(optionsList);
    }
  }

  useEffect(() => {
    StructureContainers.getContainerOptions(id)
      .then((data) => {
        fetchAndCreateInitialOptionsCopy(id, data && data.length ? data : undefined);
      })
      .catch(Logger.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateStructureOptions(currentOptionsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOptionsList]);

  return ownCurrentOptions ? (
    <StructureOptionsWithHandlers
      {...props}
      showMore={showMore}
      updateStructureOptionsDialog={updateStructureOptionsDialog}
      wrapperClassName={cn('structure-options-container', { 'structure-options-container--vertical': isVerticalLayout })}
    />
  ) : null;
}

StructureOptionsContainer.propTypes = {
  id: PropTypes.string.isRequired,
  onCurrentOptionsChange: PropTypes.func,
  fetchAndCreateInitialOptionsCopy: PropTypes.func,
  isVerticalLayout: PropTypes.bool,
  currentOptionsList: PropTypes.array,
  ownCurrentOptions: PropTypes.instanceOf(Map),
};

const mapStateToProps = (state, ownProps) => ({
  currentOptionsList: currentOptionsNameValueObjectsArraySelector(state, ownProps),

  // Consistent with StructureOptionsDialogContainer
  initialOptions: initialOptionsSelector(state),
  ownCurrentOptions: ownCurrentOptionsSelector(state, ownProps),
  disableIncludeAndMoreGroup: isSimilarOptionCheckedSelector(state, ownProps),
});

const mapDispatchToProps = {
  fetchAndCreateInitialOptionsCopy: fetchAndCreateInitialOptionsCopyAction,

  // Consistent with StructureOptionsDialogContainer
  updateInputValue: updateInputValueAction,
  toggleRadioOption: toggleRadioOptionAction,
  toggleCheckboxOption: toggleCheckboxOptionAction,
  toggleSubRadioOption: toggleSubRadioOptionAction,
  updateSavedInfoWithCurrent: updateSavedInfoWithCurrentAction,
  setCurrentOptionsSameAsSaved: setCurrentOptionsSameAsSavedAction,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StructureOptionsContainer));
